export const safeParseJSON = <T>(raw: string | null, fallback: T): T => {
  if (!raw) return fallback;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
};

export const safeParseArray = <T>(raw: string | null, itemGuard: (val: unknown) => val is T, fallback: T[] = []): T[] => {
  const parsed = safeParseJSON<unknown>(raw, fallback as unknown as T[]);
  if (!Array.isArray(parsed)) return fallback;
  return parsed.filter(itemGuard);
};

export const isString = (val: unknown): val is string => typeof val === 'string';
